module.exports = __webpack_public_path__ + "media/veracruz/calendario_actividades_veracruz-16eec32e.png";